// ------------------------------
// EA Sticky Cart Fix for Product Grid
// ------------------------------
// Purpose: Prevents theme cart redirect and opens EA Sticky Cart drawer
// ------------------------------

document.addEventListener('DOMContentLoaded', () => {
  console.log('EA Drawer Fix active');

  // Listen for clicks on any Add-to-Cart button in product grids
  document.body.addEventListener('click', (e) => {
    const addButton = e.target.closest('button, .add-to-cart, .product-card__add, form[action*="/cart/add"] [type="submit"]');

    // Run only if clicked outside a product page
    if (addButton && !window.location.pathname.includes('/products/')) {
      console.log('Grid Add to Cart detected');

      // Stop default behaviour (prevent immediate redirect)
      e.preventDefault();

      // Find the nearest form (some grids have hidden forms)
      const form = addButton.closest('form');
      if (!form) return;

      // Build form data and POST to Shopify cart/add.js
      const formData = new FormData(form);

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      })
        .then((res) => res.json())
        .then((data) => {
          console.log('Item added successfully:', data);

          // Open EA Sticky Cart drawer smoothly (if available)
          if (
            window.EAStickyCart &&
            typeof EAStickyCart.open === 'function' &&
            !document.querySelector('.ea-sticky-cart-drawer.open')
          ) {
            setTimeout(() => {
              EAStickyCart.open();
            }, 150); // 0.15s delay for smooth animation
          }
        })
        .catch((err) => {
          console.warn('Error adding to cart:', err);
        });
    }
  });

  // Optional: if the theme emits an 'ajaxProduct:added' event, refresh the app drawer
  document.body.addEventListener('ajaxProduct:added', () => {
    if (window.EAStickyCart && typeof EAStickyCart.refresh === 'function') {
      EAStickyCart.refresh();
    }
  });
});
